import { render, staticRenderFns } from "./dxBarChart.vue?vue&type=template&id=3a344f66"
import script from "./dxBarChart.ts?vue&type=script&lang=js&external"
export * from "./dxBarChart.ts?vue&type=script&lang=js&external"
import style0 from "./dxBarChart.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports